import ProvisionExplore from '../../assets/images/provision-explore.jpg'
import MigrateToAsCodeExplore from '../../assets/images/migrate-to-as-code-explore.jpg'
import AutomationAssessmentEmplore from '../../assets/images/automation-assessment-explore.jpg'
import AccountFactoryExplore from '../../assets/images/account-factory-explore.jpeg'


export const benefits = ["Speed and Efficiency", "Reduced Risk of Human Error", "Reusability", "Consistency", "Scalability"]

export const features = [
  {
    id: 1,
    title: "Self-Service Provisioning",
    desc: "Accelerates infrastructure deployment across cloud platforms while ensuring security compliance. Simplify workflows and prioritize innovation with seamless infrastructure management",
    img: ProvisionExplore
  },
  {
    id: 2,
    title: "Automation Assessment",
    desc: "Evaluates your cloud infrastructure, comparing Terraform-managed to non-managed resources. It provides an automation percentage score and lists resources not yet Terraform-managed, enabling informed optimization",
    img: AutomationAssessmentEmplore
  },
  {
    id: 3,
    title: "Migrate to As Code",
    desc: "This feature automates Terraform file generation from existing infrastructure, encompassing all dependencies. Its Import functionality seamlessly integrates current setups into Infrastructure as Code (IaC)",
    img: MigrateToAsCodeExplore
  },
  {
    id: 4,
    title: "Account Factory",
    desc: "Automates AWS account creation and customization with a single click. Newly created accounts adhere to security best practices, provide restricted access, and streamline developer setup for prompt infrastructure deployment",
    img: AccountFactoryExplore
  }
]